import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";
import {Component, Injector} from "@angular/core";
import {SupplierSearchPageComponent} from "../supplier-search-page/supplier-search-page.component";
import {SupplierEditPageComponent} from "../supplier-edit-page/supplier-edit-page.component";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {SupplierSearchModel} from "../supplier-search.model";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";

@Component({
    selector: "wbo-supplier-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(SupplierSingleSelectEditControlComponent),
        provideSearchModel(SupplierSearchModel)
    ]
})
export class SupplierSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<SupplierSearchModel> {
    constructor(model: SupplierSearchModel, injector: Injector) {
        super(model, injector, "vendorId", "name");

        this.extendedSearchComponent = SupplierSearchPageComponent;
        this.extendedEditComponent = SupplierEditPageComponent;
    }
}
